import { isFullHtmlDocument, looksLikeHtmlSource } from './emailHtmlDocument'

const DESCRIPTION_TEMPLATE_TAG =
  /<(div|table|tbody|thead|tfoot|tr|td|th|style|link|meta|script|head|body|html|section|article|header|footer|nav|iframe|svg|colgroup|col)\b/i

/** Listing/description HTML templates (fragments or full documents), not simple rich-text from the visual editor. */
export const isDescriptionHtmlTemplate = (value: string): boolean => {
  const trimmed = value.trim()
  if (!trimmed) return false
  if (isFullHtmlDocument(trimmed)) return true
  if (!looksLikeHtmlSource(trimmed)) return false
  if (DESCRIPTION_TEMPLATE_TAG.test(trimmed)) return true
  if (/\sstyle\s*=\s*['"]/i.test(trimmed)) return true
  return false
}

export const isDescriptionHtmlSource = (value: string): boolean => isDescriptionHtmlTemplate(value)

export const shouldPersistDescriptionAsHtmlSource = (
  value: string,
  htmlSource?: boolean
): boolean => htmlSource === true || isDescriptionHtmlTemplate(value)

const encodeHtmlText = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

/** Encode each script element, including its contents. An unclosed script is encoded through the end of the value. */
export const encodeDescriptionScriptBlocks = (value: string): string =>
  value.replace(/<script\b[^>]*>[\s\S]*?(?:<\/script>|$)/gi, (block) => encodeHtmlText(block))

const decodeVisualDescriptionEntities = (value: string): string =>
  value
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')

export const prepareDescriptionValueForSave = (
  value: string,
  options?: { htmlSource?: boolean }
): string => {
  if (shouldPersistDescriptionAsHtmlSource(value, options?.htmlSource)) {
    return encodeDescriptionScriptBlocks(value)
  }

  return encodeDescriptionScriptBlocks(decodeVisualDescriptionEntities(value))
}

export const limitDescriptionValue = (
  value: string,
  limit: number | null | undefined,
  htmlSource: boolean
): string => {
  if (htmlSource || isDescriptionHtmlTemplate(value) || limit == null || limit <= 0) return value
  return value.slice(0, limit)
}
